export function updateBoundsFromGeoArrowSamples(flatCoords, nDim, bounds) {
  let sampleSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
  const numberOfFeatures = flatCoords.length / nDim;
  const sampleStep = Math.max(Math.floor(numberOfFeatures / sampleSize), 1);
  const newBounds = [...bounds];
  for (let i = 0; i < numberOfFeatures; i += sampleStep) {
    const lng = flatCoords[i * nDim];
    const lat = flatCoords[i * nDim + 1];
    if (lng < newBounds[0]) {
      newBounds[0] = lng;
    }
    if (lat < newBounds[1]) {
      newBounds[1] = lat;
    }
    if (lng > newBounds[2]) {
      newBounds[2] = lng;
    }
    if (lat > newBounds[3]) {
      newBounds[3] = lat;
    }
  }
  return newBounds;
}
//# sourceMappingURL=get-arrow-bounds.js.map